<template>
  <div>
    <!-- Page Banner -->
    <section class="page-banner bgs-cover overlay pt-50 ban-h mob-ban" style="background-image: url(/assets/images/digital.jpg)">
      <div class="container">
        <div class="banner-inner">
          <h1 class="page-title2">{{ $t('services.digital.subtitle') }}<br><span>{{ $t('services.digital.subtitleSpan1') }}</span> <br><span>{{ $t('services.digital.subtitleSpan2') }}</span></h1>
        </div>
      </div>
    </section>

    <!-- Services Description -->
    <section>
      <div class="container ser-des">
        <h1 class="mt-80">{{ $t('services.digital.title') }}</h1>
        <p class="font-2 mt-30 mb-80 lh2 mob-ban-title">
          {{ $t('services.digital.description') }}
          <br><br>
          {{ $t('services.digital.descriptionPart2') }}
        </p>
      </div>
    </section>

    <!-- Services Grid Section -->
    <section class="featured-section bgs-cover pt-60 pb-60" style="background-image: url(/assets/images/feature/feature-bg.jpg)">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-xl-4 col-md-6">
            <div class="feature-item wow fadeInUp delay-0-2s exp-b">
              <div class="icon align-i">
                <img src="/assets/images/icon/app-d.png" />
              </div>
              <div class="feature-content align-c">
                <h5>{{ $t('services.digital.servicesGrid.mobileApp') }}</h5>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-md-6">
            <div class="feature-item wow fadeInUp delay-0-2s exp-b">
              <div class="icon align-i">
                <img src="/assets/images/icon/frontend.png" />
              </div>
              <div class="feature-content align-c">
                <h5>{{ $t('services.digital.servicesGrid.frontend') }}</h5>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-md-6">
            <div class="feature-item wow fadeInUp delay-0-2s exp-b">
              <div class="icon align-i">
                <img src="/assets/images/icon/backend.png" />
              </div>
              <div class="feature-content align-c">
                <h5>{{ $t('services.digital.servicesGrid.backend') }}</h5>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-md-6">
            <div class="feature-item wow fadeInUp delay-0-2s exp-b">
              <div class="icon align-i">
                <img src="/assets/images/icon/api.png" />
              </div>
              <div class="feature-content align-c">
                <h5>{{ $t('services.digital.servicesGrid.api') }}</h5>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-md-6">
            <div class="feature-item wow fadeInUp delay-0-2s exp-b">
              <div class="icon align-i">
                <img src="/assets/images/icon/crosse-p.png" />
              </div>
              <div class="feature-content align-c">
                <h5>{{ $t('services.digital.servicesGrid.crossPlatform') }}</h5>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-md-6">
            <div class="feature-item wow fadeInUp delay-0-2s exp-b">
              <div class="icon align-i">
                <img src="/assets/images/icon/dam.png" />
              </div>
              <div class="feature-content align-c">
                <h5>{{ $t('services.digital.servicesGrid.digitalAsset') }}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Mobile App Development Section -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-10 bg-bg1 pad-btm_imp" id="MobileAppDevelopment">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6">
            <div class="about-eight-images rmb-55 wow rmb-30 fadeInLeft delay-0-2s">
              <img src="/assets/images/services/front-end.png" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title">
                    <h2>{{ $t('services.digital.servicesOffered.mobileApp.title') }} <span>{{ $t('services.digital.servicesOffered.mobileApp.titleSpan') }}</span></h2>
                  </div>
                </div>
              </div>
              <p>{{ $t('services.digital.servicesOffered.mobileApp.description') }}</p>
              <ul class="list-style-three mt-15">
                <li v-for="(feature, index) in $tm('services.digital.servicesOffered.mobileApp.features')" :key="index">
                  {{ feature }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Frontend Development Section -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100 pad-btm_imp" id="FrontendDevelopment">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 order2">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title">
                    <h2><span>{{ $t('services.digital.servicesOffered.frontend.titleSpan') }}</span> {{ $t('services.digital.servicesOffered.frontend.title') }}</h2>
                  </div>
                </div>
              </div>
              <p>{{ $t('services.digital.servicesOffered.frontend.description') }}</p>
              <ul class="list-style-three mt-15">
                <li v-for="(feature, index) in $tm('services.digital.servicesOffered.frontend.features')" :key="index">
                  {{ feature }}
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-6 order1">
            <div class="about-eight-images rmb-55 wow rmb-30 fadeInLeft delay-0-2s">
              <img class="mar-l" src="/assets/images/services/app.png" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Backend Development Section -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100 bg-bg1 back-end pad-btm_imp" id="BackendDevelopment" style="background-image: url(/assets/images/back-end.jpg)">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6">
            <!-- Empty column for spacing -->
          </div>
          <div class="col-md-6  ">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w dclr-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title">
                    <h2><span>{{ $t('services.digital.servicesOffered.backend.titleSpan') }}</span> {{ $t('services.digital.servicesOffered.backend.title') }}</h2>
                  </div>
                </div>
              </div>
              <p class="dclr-w">{{ $t('services.digital.servicesOffered.backend.description') }}</p>
              <ul class="list-style-three list-style-b mt-15">
                <li v-for="(feature, index) in $tm('services.digital.servicesOffered.backend.features')" :key="index">
                  {{ feature }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- API Development Section -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100 pad-btm_imp" id="APIDevelopment">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 order2">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title">
                    <h2><span>{{ $t('services.digital.servicesOffered.api.titleSpan') }}</span> {{ $t('services.digital.servicesOffered.api.title') }}</h2>
                  </div>
                </div>
              </div>
              <p>{{ $t('services.digital.servicesOffered.api.description') }}</p>
              <ul class="list-style-three mt-15">
                <li v-for="(feature, index) in $tm('services.digital.servicesOffered.api.features')" :key="index">
                  {{ feature }}
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-6 order1">
            <div class="about-eight-images rmb-55 rmb-30 wow fadeInLeft delay-0-2s">
              <img class="mar-l" src="/assets/images/services/api.png" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Cross Platform App Development Section -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100 bg-bg1 pad-btm_imp" id="CrossPlatformAppDevelopment">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6">
            <div class="about-eight-images rmb-55 rmb-30 wow fadeInLeft delay-0-2s">
              <img src="/assets/images/services/cross-plat.png" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title">
                    <h2><span>{{ $t('services.digital.servicesOffered.crossPlatform.titleSpan') }}</span> {{ $t('services.digital.servicesOffered.crossPlatform.title') }}</h2>
                  </div>
                </div>
              </div>
              <p>{{ $t('services.digital.servicesOffered.crossPlatform.description') }}</p>
              <ul class="list-style-three mt-15">
                <li v-for="(feature, index) in $tm('services.digital.servicesOffered.crossPlatform.features')" :key="index">
                  {{ feature }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Digital Asset Management Section -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100 pad-btm_imp" id="DigitalAssetManagement">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 order2">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title">
                    <h2><span>{{ $t('services.digital.servicesOffered.digitalAsset.titleSpan') }}</span> {{ $t('services.digital.servicesOffered.digitalAsset.title') }}</h2>
                  </div>
                </div>
              </div>
              <p>{{ $t('services.digital.servicesOffered.digitalAsset.description') }}</p>
              <ul class="list-style-three mt-15">
                <li v-for="(feature, index) in $tm('services.digital.servicesOffered.digitalAsset.features')" :key="index">
                  {{ feature }}
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-6 order1">
            <div class="about-eight-images rmb-55 rmb-30 wow fadeInLeft delay-0-2s">
              <img class="mar-l" src="/assets/images/services/dam.png" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Our Products Section -->
    <section class="about-tab-section pb-70 rpb-100 pt-80 op" id="OurProducts">
      <div class="container">
        <div class="section-title text-center mb-55">
          <h2>{{ $t('services.digital.ourProducts.title') }}</h2>
        </div>
        <ul class="nav about-tab">
          <li>
            <a class="active" data-toggle="tab" href="#tabContent1">
              <h3>{{ $t('services.digital.ourProducts.octave.title') }}</h3>
            </a>
          </li>
          <li>
            <a data-toggle="tab" href="#tabContent2">
              <h3>{{ $t('services.digital.ourProducts.brandKit.title') }}</h3>
            </a>
          </li>
          <li>
            <a data-toggle="tab" href="#tabContent3">
              <h3>{{ $t('services.digital.ourProducts.damVerse.title') }}</h3>
            </a>
          </li>
        </ul>
        <div class="tab-content about-tab-content abt1">
          <div class="tab-pane fade show active" id="tabContent1">
            <div class="row align-items-center">
              <div class="col-lg-12">
                <p class="mb-50 f-20">{{ $t('services.digital.ourProducts.octave.description') }}</p>
                <div class="about-contentrpr-0 wow fadeInRight delay-0-2s">
                  <div class="about-six-content rmr-0 wow fadeInLeft delay-0-2s">
                    <div class="section-title mb-35">
                      <h2 class="df">{{ $t('services.digital.ourProducts.octave.featuresTitle') }}</h2>
                    </div>
                    <div class="service-item-six sis-w" v-for="(feature, index) in $tm('services.digital.ourProducts.octave.features')" :key="index">
                      <div class="service-content sc-fw">
                        <h5>{{ feature.title }}</h5>
                        <p>{{ feature.description }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="tabContent2">
            <div class="row align-items-center">
              <div class="col-lg-12">
                <p class="mb-50 f-20">{{ $t('services.digital.ourProducts.brandKit.description') }}</p>
                <div class="about-contentrpr-0 wow fadeInRight delay-0-2s">
                  <div class="about-six-content rmr-0 wow fadeInLeft delay-0-2s">
                    <div class="section-title mb-35">
                      <h2 class="df">{{ $t('services.digital.ourProducts.brandKit.featuresTitle') }}</h2>
                    </div>
                    <div class="service-item-six sis-w" v-for="(feature, index) in $tm('services.digital.ourProducts.brandKit.features')" :key="index">
                      <div class="service-content sc-fw">
                        <h5>{{ feature.title }}</h5>
                        <p>{{ feature.description }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="tabContent3">
            <div class="row align-items-center">
              <div class="col-lg-12">
                <p class="mb-50 f-20">{{ $t('services.digital.ourProducts.damVerse.description') }}</p>
                <div class="about-contentrpr-0 wow fadeInRight delay-0-2s">
                  <div class="about-six-content rmr-0 wow fadeInLeft delay-0-2s">
                    <div class="section-title mb-35">
                      <h2 class="df">{{ $t('services.digital.ourProducts.damVerse.featuresTitle') }}</h2>
                    </div>
                    <div class="service-item-six sis-w" v-for="(feature, index) in $tm('services.digital.ourProducts.damVerse.features')" :key="index">
                      <div class="service-content sc-fw">
                        <h5>{{ feature.title }}</h5>
                        <p>{{ feature.description }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Our Clientele Section -->
    <section class="pt-100 pb-100 abs1">
      <div class="container">
        <div class="section-title text-center mb-80 mb-n">
          <h2 class="client-mb">{{ $t('services.digital.ourClientele.title') }}</h2>
          <p class="client-f">{{ $t('services.digital.ourClientele.description') }}</p>
        </div>
        <div class="col-md-12 d-flex justify-content-between c-logo">
          <img src="/assets/images/client_logo.png" />
        </div>
      </div>
      <div class="abs2"></div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ServicesDigital'
}
</script>
